import { __rest } from "tslib";
import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import React from 'react';
export const dotVariants = cva('cmp-dot', {
    variants: {
        variant: {
            light: 'cmp-dot-light',
            dark: 'cmp-dot-dark',
            default: 'cmp-dot-default',
            primary: 'cmp-dot-primary',
            warn: 'cmp-dot-warn',
            danger: 'cmp-dot-danger',
            success: 'cmp-dot-success',
            epic: 'cmp-dot-epic',
            alert: 'cmp-dot-alert',
        },
        size: {
            small: 'cmp-dot-small',
            large: 'cmp-dot-large',
            medium: 'cmp-dot-medium',
        },
    },
    defaultVariants: {
        size: 'medium',
    },
});
const Dot = React.forwardRef((_a, ref) => {
    var { color, style, as: Component = 'i', className, variant, size } = _a, props = __rest(_a, ["color", "style", "as", "className", "variant", "size"]);
    return (React.createElement(Component, Object.assign({ ref: ref, className: clsx(dotVariants({ variant, size }), className), style: color ? Object.assign(Object.assign({}, style), { backgroundColor: color }) : style }, props)));
});
Dot.displayName = 'Dot';
export { Dot };
//# sourceMappingURL=index.js.map